<template>
    <md-card>
        <md-card-content>
            <div class="md-layout">
                <div class="md-layout-item md-size-100">
                    <slot name="title"></slot>
                    <slot name="sub-title"></slot>
                </div>
            </div>
        </md-card-content>
    </md-card>
</template>

<script>
export default {
    name: 'SimpleCard',
};
</script>
<style scoped>
.title {
    color: #565656;
    font-weight: 500;
    font-size: medium;
}

.sub-title {
    color: gray;
    font-size: small;
}
</style>
